import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    height: 100%;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
